import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useCommonTranslation } from "@/hooks/useCommonTranslation";
import { cn } from "@/lib/cn";
import { useState } from "react";
import type { Person } from "../Combobox/PersonSelectorCombobox";
import PersonSelectorCombobox from "../Combobox/PersonSelectorCombobox";
import Icon from "../Icon/Icon";
import { HStack } from "../Layout";
import { Button } from "../ui/button";

type Props = {
  value?: Person;
  onChange: (option?: Person) => void;
  allowEmpty?: boolean;
  disabled?: boolean;
  placeHolder?: string;
  width?: number;
  disabledPersonIds?: Set<string>;
  /** 指定しない場合自律制御 */
  open?: boolean;
  setOpen?: (open: boolean) => void;
};

/**
 * Worker の選択肢に対応した Select
 */
export function WorkerSelect(props: Props) {
  const tc = useCommonTranslation();

  const [_open, _setOpen] = useState(false);
  const open = props.open ?? _open;
  const setOpen = props.setOpen ?? _setOpen;

  return (
    <Popover open={open} onOpenChange={() => setOpen(!open)}>
      <HStack>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={open}
            className={cn(
              "justify-between overflow-hidden text-ellipsis",
              props.width && `w-[${props.width}px]`,
              !props.value && "text-muted-foreground",
            )}
            disabled={props.disabled}
          >
            {props.value?.name || tc("pleaseSelect")}
            <Icon
              iconName="ChevronDownIcon"
              className="ml-2 shrink-0 opacity-50"
            />
          </Button>
        </PopoverTrigger>
        {props.allowEmpty && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => props.onChange(undefined)}
          >
            <Icon iconName="XIcon" />
          </Button>
        )}
      </HStack>
      <PopoverContent
        className={cn(
          "w-full overflow-hidden p-0",
          props.width && `w-[${props.width}px]`,
        )}
        align="start"
      >
        <PersonSelectorCombobox
          onSelect={(person) => {
            props.onChange(person);
            setOpen(false);
          }}
          disabledPersonIds={props.disabledPersonIds}
          onClose={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
